import { subCompaniesApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SUB_COMPANY_TASK_USERS_ACTION_TYPE = createNamedActions('subCompanyTaskUsers', {
  GET_USERS: 'GET_USERS',
  RESET_STATE: 'RESET_STATE',
});

export const getSubCompanyTaskUsersAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await subCompaniesApi.getSubCompanyUsers(params);

  return dispatch({
    type: SUB_COMPANY_TASK_USERS_ACTION_TYPE.GET_USERS,
    payload: data || [],
  });
});

export const resetSubCompanyTaskUsersAction = () => ({
  type: SUB_COMPANY_TASK_USERS_ACTION_TYPE.RESET_STATE,
});
